import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`navigation-header ${isScrolled ? 'shadow-md' : ''}`}
      style={{ 
        position: 'sticky',
        top: 0,
        zIndex: 100,
        transition: 'all 0.3s ease',
        background: isScrolled ? 'var(--bg-primary)' : 'var(--bg-primary)',
        backdropFilter: isScrolled ? 'blur(10px)' : 'none',
        boxShadow: isScrolled ? '0 4px 20px rgba(218, 165, 32, 0.1)' : 'none'
      }}
    >
      <div className="container" style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 40px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 0' }}>
          {/* Logo */}
          <div 
            onClick={() => scrollToSection('hero')} 
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px' }}
          >
            <img 
              src={companyInfo.logo} 
              alt={companyInfo.name}
              style={{ height: '60px', width: 'auto' }}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="navigation-menu" style={{ display: 'none' }}>
            <button onClick={() => scrollToSection('tentang')} className="navigation-link">Tentang Kami</button>
            <button onClick={() => scrollToSection('layanan')} className="navigation-link">Layanan</button>
            <button onClick={() => scrollToSection('portfolio')} className="navigation-link">Portfolio</button>
            <button onClick={() => scrollToSection('testimoni')} className="navigation-link">Testimoni</button>
            <button onClick={() => scrollToSection('kontak')} className="navigation-link">Kontak</button>
          </nav>

          {/* Desktop Utilities */}
          <div className="navigation-utilities" style={{ display: 'none', alignItems: 'center', gap: '20px' }}>
            <a 
              href={companyInfo.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
            >
              <Phone size={18} />
              Konsultasi Gratis
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="mobile-menu-toggle"
            style={{ 
              display: 'block', 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer', 
              padding: '8px',
              color: 'var(--text-primary)'
            }}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div 
            className="mobile-menu"
            style={{
              display: 'block',
              paddingBottom: '20px',
              borderTop: '1px solid var(--border-light)'
            }}
          >
            <nav style={{ display: 'flex', flexDirection: 'column', gap: '0', paddingTop: '20px' }}>
              <button 
                onClick={() => scrollToSection('tentang')} 
                className="navigation-link"
                style={{ textAlign: 'left', width: '100%', padding: '16px 0', borderBottom: '1px solid var(--border-subtle)' }}
              >
                Tentang Kami
              </button>
              <button 
                onClick={() => scrollToSection('layanan')} 
                className="navigation-link"
                style={{ textAlign: 'left', width: '100%', padding: '16px 0', borderBottom: '1px solid var(--border-subtle)' }}
              >
                Layanan
              </button>
              <button 
                onClick={() => scrollToSection('portfolio')} 
                className="navigation-link"
                style={{ textAlign: 'left', width: '100%', padding: '16px 0', borderBottom: '1px solid var(--border-subtle)' }}
              >
                Portfolio
              </button>
              <button 
                onClick={() => scrollToSection('testimoni')} 
                className="navigation-link"
                style={{ textAlign: 'left', width: '100%', padding: '16px 0', borderBottom: '1px solid var(--border-subtle)' }}
              >
                Testimoni
              </button>
              <button 
                onClick={() => scrollToSection('kontak')} 
                className="navigation-link"
                style={{ textAlign: 'left', width: '100%', padding: '16px 0', borderBottom: '1px solid var(--border-subtle)' }}
              >
                Kontak
              </button>
              <a 
                href={companyInfo.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                style={{ marginTop: '24px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
              >
                <Phone size={18} />
                Konsultasi Gratis
              </a>
            </nav>
          </div>
        )}
      </div>

      <style jsx="true">{`
        @media (min-width: 1024px) {
          .navigation-menu {
            display: flex !important;
            gap: 40px;
          }
          .navigation-utilities {
            display: flex !important;
          }
          .mobile-menu-toggle {
            display: none !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
